import React, { FocusEventHandler, useCallback, useState } from "react";
import { Box, Card } from "rebass";
import { FieldProps } from "formik";
import { IconBaseProps } from "react-icons";
import omit from "lodash/omit";

import { MailSVG } from "../../components/svg/MailSVG";
import { PasswordSVG } from "../../components/svg/PasswordSVG";
import { Input as StyledInput } from "../../components/styled/Input";

interface IProps extends FieldProps {
  type?: string;
  placeholder?: string;
}

const icons: Record<string, React.FC<IconBaseProps> | undefined> = {
  email: MailSVG,
  password: PasswordSVG,
};

export const Input: React.FC<IProps> = (
  {
    field,
    form: { isSubmitting },
    type = "text",
    placeholder = "placeholder",
  }
) => {
  const [isFocus, setIsFocus] = useState(false);
  const handleOnFocus = useCallback(() => {
    setIsFocus(true);
  }, []);
  const handleOnBlur = useCallback<FocusEventHandler>((e) => {
    setIsFocus(false);

    field.onBlur(e);
  }, [field]);

  const Icon = icons[type];

  return (
    <Card
      width={1}
      p="14px 25px"
      backgroundColor="#fff"
      boxShadow={isFocus ? "0 3px 29px 0 rgba(0,0,0,.23)" : "none"}
      css="display: flex; border-radius: 5px; & + & { margin-top: 20px; }"
    >
      <StyledInput
        flex="1"
        type={type}
        placeholder={placeholder}
        p="0"
        backgroundColor="transparent"
        fontSize="18px"
        lineHeight="1.44"
        disabled={isSubmitting}
        onFocus={handleOnFocus}
        onBlur={handleOnBlur}
        {...omit(field, ["onBlur"])}
      />

      {
        Icon && (
          <Box ml="15px" color="wild-blue">
            <Icon />
          </Box>
        )
      }
    </Card>
  );
};
